import { Component, ViewChild, OnInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { DocumentoService } from 'src/app/services/documento.service';

import { MatDialog } from '@angular/material/dialog';
import { GLOBAL } from 'src/app/services/global';
import { switchAll } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from "../../../services/user.service";
import { Title } from '@angular/platform-browser';
import { bounceAnimation } from 'angular-animations';
import { ToastrService } from 'ngx-toastr';
import { FormControl, Validators } from '@angular/forms';

declare const swal: any;
const url = GLOBAL.url;

declare var jQuery: any;
declare var $: any;
const uri = url + 'upload/file';

@Component({
    selector: "page-archivos",
    templateUrl: "./archivos.component.html",
    styleUrls: ["./archivos.component.css"],
    providers: [DocumentoService],
    animations: [
        bounceAnimation(),
    ]

})

export class ArchivosComponent implements OnInit {
    panelOpenState = false;
    public yasubieron = false;
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('modalArchivos') modalArchivos: TemplateRef<any>;
    @ViewChild('modalAdjuntos') modalAdjuntos: TemplateRef<any>;
    @ViewChild('confirmaSubida') confirmaSubida: TemplateRef<any>;

    uploader: FileUploader = new FileUploader({ url: uri })
    attachmentList: any = [];
    public hasBaseDropZoneOver: boolean = false;
    public hasOnFileDrop: boolean = false;
    public inputList = [];
    labelDrop
    inputValue
    form
    isReady = false;
    public archivosForm
    public archivosSubidos = [];
    public archivoSubidoFind = false;
    public cantArSubidosObligatorios = 0;
    public arrayArchivos = [];
    public interval
    private pdfUrl = GLOBAL.pdfUrl;
    public acotado = GLOBAL.acotado;
    public nombreMuni = GLOBAL.nombreMuni;
    public docAccept = GLOBAL.docAccept;
    public adjuntoActual
    public enableUpload = false
    public adjuntos = []
    public files = []
    public rows = []
    public documentoNombre = ''
    public maxSizeFiles = 75000000
    public actualSizeFiles = 0
    public animate = false;
    public disableNombre = false;
    //archivos lista
    nombreForm;
    nombreArchivo;
    nombreDeDocumento;
    nombreDeArchivo;
    inputdatos = [];
    storageDatos = [];
    doc1;
    doc2;
    doc3;
    doc4;
    doc5;
    doc6;
    public demolicion_archivo;
    fileNames = [];
    docNames = [];
    docRepetido: boolean = false;
    fileRepetido: boolean = false;
    newFile: File;
    newFiles: FileList;

    // public docNombre = new FormControl('', [Validators.required ]);



    constructor(private _documentosServices: DocumentoService, private dialog: MatDialog, private cd: ChangeDetectorRef, private spinner: NgxSpinnerService, private toastr: ToastrService) {



        this.nombreArchivo = ''
        if (this.acotado == true) {
            this.form =localStorage.getItem("formId")

        } else {

            this.form = JSON.parse(localStorage.getItem("form"))
        }
        this.demolicion_archivo = localStorage.getItem("archivo_demolicion")

        if (!JSON.parse(localStorage.getItem("adjuntos"))) {
            localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos));
        } else {
            this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));
        }



        this.uploader.onAfterAddingFile = (file) => {
            file.withCredentials = false

        }

        this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            //console.log('onCompleteitem response:', response);
            ////console.log(response)

            this.attachmentList.push(response);



        }

    }


    ngOnInit() {
        this.getUploaders();
        if (this.acotado != true) {

            setTimeout(() => this.dialog.open(this.openModal))
        }
    }

    cerrarModal() {
        this.nombreArchivo = ''
        this.dialog.closeAll();

    }

    fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }
    onFileDrop(e: any, archivo = null) {

        this.archivoSubidoFind = false;
        for (let i = 0; i < this.archivosForm.length; i++) {
            if (this.archivosForm[i].name == archivo.name) {
                this.archivosForm[i].ready = true;
            }
        }
        this.archivosSubidos.push(archivo)

        if (this.archivosSubidos) {
            if (this.arrayArchivos.length == 0) {
                this.arrayArchivos.push(archivo)
                ////console.log(this.arrayArchivos)
            } else {

                ////console.log("entre en arrayarchivos")
                ////console.log(this.arrayArchivos)
                for (let i = 0; i < this.arrayArchivos.length; i++) {
                    ////console.log(this.arrayArchivos[i])
                    ////console.log(archivo.name)
                    if (this.arrayArchivos[i].name == archivo.name) {

                        ////console.log("encontre el mismo nombre")
                        this.archivoSubidoFind = true;
                    }


                }
            }
        }

        if (!this.archivoSubidoFind) {
            this.arrayArchivos.push(archivo)
            if (archivo.obligatorio) {
                this.cantArSubidosObligatorios = this.cantArSubidosObligatorios + 1
                ////console.log("this.cantArSubidosObligatorios: ", this.cantArSubidosObligatorios)
                ////console.log("Falta subir archivos");

            }
        }




        this.nombreForm = archivo.name;
        this.unir(archivo.name);
    }

    // onInsert() {
    //     var subidos = { "archivosSubidos": false };
    //     localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
    // }

    marcarArchivos() {
        /*
        var contObligatorios = 0
        for (let i = 0; i < this.archivosForm.length; i++) {
            if (this.archivosForm[i].obligatorio) {
                contObligatorios = contObligatorios + 1
            }
            localStorage.setItem("archivos_obligatorios", JSON.stringify(contObligatorios));
        }
        if (this.cantArSubidosObligatorios >= contObligatorios) {
            */
        var subidos = { "archivosSubidos": true };
        localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
        swal({
            type: 'success',
            title: 'Archivos cargados',
            text: '<p>ya puedes continuar</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        }).then(
            () => {
                window.scrollTo(0, document.body.scrollHeight);
            }
        );
        /*
    }
    else {
        var subidos = { "archivosSubidos": false };
        localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
        swal({
            type: 'error',
            title: 'No has subido todos los archivos obligatorios ',
            text: '<p>adjuntalos y presiona el boton subir archivos para continuar</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        })
    }*/

    }




    fileInput(archivo) {
        //console.log(archivo)

    }

    getUploaders() {
        var intervalStart = false

        if (!intervalStart) {
            this.interval = setInterval(() => {
                if (localStorage.getItem("archivos2")) {
                    intervalStart = true
                }
            }, 2000)
        }

        if (intervalStart) {
            this.archivosForm = localStorage.getItem("archivos2")
            ////console.log(this.archivosForm)
        }

        this._documentosServices.getUploaders().subscribe(
            response => {
                if (this.acotado == true) {
                    this.form = localStorage.getItem("formId")

                } else {
                    this.form = localStorage.getItem("form")

                }

                if (this.form == '5.8' && (this.demolicion_archivo == false || this.demolicion_archivo == "false")) {
                    var contador = 0;
                    for (let i = 0; i < response.documentos.length; i++) {

                        if (this.form == response.documentos[i].name) {



                            while (contador < 6) {
                                ////console.log(contador);
                                this.arrayArchivos.push(response.documentos[i].archivos[contador])

                                contador++

                            }
                            this.archivosForm = this.arrayArchivos


                        }
                    }
                } else {
                    for (let i = 0; i < response.documentos.length; i++) {

                        if (this.form == response.documentos[i].name) {
                            this.archivosForm = response.documentos[i].archivos
                        }
                    }
                }


            },
            error => {
                //console.log(error);
            }
        )
    }


    removeAll() {
        for (let i = 0; i < this.inputList.length; i++) {
            if (this.inputList[i].ready) {
                this.inputList[i].ready = false;
            }
        }
        this.inputdatos.splice(0);
        //localStorage.setItem("archivos", JSON.stringify([]));
    }

    removeFile(nombre) {
        /*//console.log(nombre)
        //console.log(this.inputdatos)
        //console.log(this.inputList)*/
        var index;
        for (let i = 0; i < this.inputdatos.length; i++) {
            if (this.inputdatos[i].nombreArchivo == nombre) {
                for (let x = 0; x < this.inputList.length; x++) {
                    if (this.inputList[x].name == this.inputdatos[i].nombreForm) {
                        index = i;
                        this.inputList[x].ready = false;
                    }
                }
            }
        }
        this.inputdatos.splice(index, 1);
        //this.setStorage();
    }

    unir(fileType = '') {
        this.uploader.queue[this.uploader.queue.length - 1].file.name = fileType + '-' + new Date().getTime() + '-' + this.uploader.queue[this.uploader.queue.length - 1].file.name
        this.nombreArchivo = this.uploader.queue[this.uploader.queue.length - 1].file.name;
        this.adjuntoActual = this.uploader.queue[this.uploader.queue.length - 1].file.name
        ////console.log("nombre del form", this.nombreForm)

        this.inputdatos.push({

            'linkArchivo': `${this.pdfUrl}/${this.nombreArchivo}`,
            'nombreForm': this.nombreForm,
        });
        localStorage.removeItem("archivos")
        ////console.log(localStorage.getItem("archivos"))
        localStorage.setItem("archivos", JSON.stringify(this.inputdatos));
        ////console.log(localStorage.getItem("archivos"))

    }
    /*
        onFileAdd(ev: any, file){
    
            //si no tiene informacion...
    
    
            let actualAdjuntos = localStorage.getItem("adjuntos");
            this.adjuntos = JSON.parse(actualAdjuntos);
    
                this. adjuntos = this.adjuntos.concat({
                    nombre: 
                })
    
                localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos));
                this.form.reset();
        }
        */
    openAdjuntosModal() {
        this.dialog.open(this.modalAdjuntos, { disableClose: true });
    }

    cancelarAdjunto() {
        let tmpName = this.uploader.queue[this.uploader.queue.length - 1].file.name
        this.removeFile(tmpName)
        this.uploader.queue[this.uploader.queue.length - 1].remove()
        localStorage.removeItem("archivos")
        localStorage.setItem("archivos", JSON.stringify(this.inputdatos))
        this.enableUpload = false
        this.nombreArchivo = ''
    }




    deleteFile(index = null) {
        if (index != null) {
            //recalcular size
            let fil: File
            fil = this.files[index].doc
            this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0
            //console.log("this.actualSizeFiles - fil.size", this.actualSizeFiles, fil.size);

            //Remove file
            //console.log("files", this.files, "index", index)
            this.files.splice(index, 1)
            let actualRow = localStorage.getItem("adjuntos");
            this.rows = JSON.parse(actualRow);
            this.rows.splice(index, 1)
            localStorage.setItem("adjuntos", JSON.stringify(this.rows));
        } else {
            //recalcular size
            let fil: File
            fil = this.files[this.files.length - 1].doc
            this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0
            //Remove file
            this.files.splice(this.files.length - 1, 1)
            let actualRow = localStorage.getItem("adjuntos");
            this.rows = JSON.parse(actualRow);
            this.rows.splice(this.rows.length - 1, 1)
            localStorage.setItem("adjuntos", JSON.stringify(this.rows));
        }
    }



    handleFileInput(files: FileList) {
        //console.log('before this.files ', this.files)
        //this.newFile: File //nuevo file
        this.newFile = files.item(0)
        this.newFiles = files;
        let actualRow = localStorage.getItem("adjuntos");
        //console.log('actualRow (  localStorage.getItem("adjuntos")  )', actualRow);
        this.rows = JSON.parse(actualRow);
        //this.nombreDeArchivo = "";//nombre despues agregar (1||+)
        //this.nombreDeDocumento = "";//nombre despues agregar (1||+)
        this.nombreArchivo = files.item(0).name
        //console.log("before nombre de archivo", this.nombreArchivo);
    }
    validarSubida() {

        this.fileRepetido = false;
        this.docRepetido = false;
        this.nombreDeDocumento = this.documentoNombre; //documentoNombre = nombre ingresado en input

        let regexp = new RegExp(/^\s+$/);
        if (this.documentoNombre.match(regexp)) {
            this.documentoNombre = this.nombreArchivo;
            this.nombreDeDocumento = this.documentoNombre;
            console.log('espacio(s) en blanco o vacio, renombrado: ', this.documentoNombre)
            this.toastr.warning(`El Nombre del Documento estaba en blanco, se renombró: ${this.nombreDeDocumento} `);
        }

        this.files.forEach(element => {
            if (element.name == this.nombreDeDocumento) {
                this.docRepetido = true;
            }
        });
        let filenameCounter = 0;
        this.nombreDeArchivo = this.nombreArchivo;
        this.files.forEach(element => {
            // //console.log('element', element)
            // //console.log('element.doc.archivo', element.doc.name)
            if (element.doc.name == this.nombreArchivo) {
                this.fileRepetido = true;
            }
        });
        console.log("this.fileRepetido", this.fileRepetido)
        console.log("this.docRepetido", this.docRepetido)
        if (!this.fileRepetido && !this.docRepetido) {
            this.adjuntoSave();
        }
        else {
            if (this.fileRepetido) {
                swal({
                    icon: 'error',
                    title: 'Archivo duplicado',
                    text: '<p>Usted ya adjunto un archivo con el mismo nombre</p>',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(() => {
                    this.cerrarModal();
                })
            }
            else if (this.docRepetido) {
                swal({
                    icon: 'error',
                    title: 'Nombre de documento duplicado',
                    text: '<p>Usted ya adjunto un documento con el mismo nombre</p>',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(() => {
                    this.cerrarModal();
                })
            }
        }
    }
    adjuntoSave(fileName = null) {


        console.log("adjuntoSave this.files", this.files);
        console.log("adjuntoSave this.nombreDeDocumento.trim()", this.nombreDeDocumento.trim());
        var subidos = { "archivosSubidos": false };
        localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
        this.files.push({ name: this.nombreDeDocumento.trim(), doc: this.newFile })
        // this.files.forEach(element => {
        //     this.docNames.push(element.name.trim());
        //     this.fileNames.push(element.doc.name.trim());
        // });

        let peso = (this.newFiles.item(0).size / 1000000) + ' MB'
        this.rows = this.rows.concat({
            name: this.nombreDeDocumento.trim(),
            archivo: this.nombreDeArchivo.trim(),
            peso: peso,
            estado: "Pendiente"
        })
        localStorage.setItem("adjuntos", JSON.stringify(this.rows));
        this.actualSizeFiles = this.actualSizeFiles + this.newFiles.item(0).size
        this.checksSize(this.files.length - 1)

        this.documentoNombre = ''
        this.cerrarModal();
        //animar
        this.animate = true;
        setTimeout(() => {
            this.animate = !this.animate;
        }, 1);
    }

    checksSize(index = null) {
        //console.log("this.actualSizeFiles > this.maxSizeFiles", this.actualSizeFiles, this.maxSizeFiles);

        if (this.actualSizeFiles > this.maxSizeFiles) {
            this.deleteFile(index)
            this.alertMaxsize()
            this.cerrarModal()
        }
    }

    alertMaxsize() {
        swal({
            icon: 'error',
            title: 'Supero el máximo de MB para tus adjuntos',
            text: '<p>Usted cuenta con un máximo de <strong>75 MB</strong> para utilizar</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        })
    }

    confirmarSubida() {

        this.dialog.open(this.confirmaSubida, { disableClose: true });

    }

    uploadAllfiles() {
        console.log('subir archivos');
        let formType = (this.form) ? this.form : 'Acotado';
        this.spinner.show();


        if (this.nombreMuni == 'Colina') {

            console.log("Enviar Archivos colina");
            this._documentosServices.uploadFiles(this.files, formType).subscribe(
                response => {
                    console.log('uploadFiles response', response)
                    this.spinner.hide();


                    var subidos = { "archivosSubidos": true };



                    this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));
                    this.adjuntos.forEach(element => {
                        element.estado = "Subido"
                    });
                    localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos))
                    let actualRow = localStorage.getItem("adjuntos");
                    this.rows = JSON.parse(actualRow);
                    console.log('JSON.parse(localStorage.getItem("adjuntos"))', JSON.parse(localStorage.getItem("adjuntos")));



                    localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
                    let alert = { icon: 'success', text: '', title: '' }

                    if (response.code == 99) {


                        this.cerrarModal();
                        console.log('yasubieron')
                        this.yasubieron = true;


                        alert.icon = 'success'
                        alert.text = '<p>Se subieron los archivos correctamente<br><br></p>'
                        alert.title = 'Archivos cargados'
                        //localStorage.setItem('ZipURL', response.url)
                    } else if (response.code == 98) {
                        alert.icon = 'error'
                        alert.text = '<p>No se adjuntaron documentos</p>'
                        alert.title = 'Archivos no cargados'
                    } else if (response.code == 97) {
                        alert.icon = 'error'
                        alert.text = '<p>No se adjuntaron documentos</p>'
                        alert.title = 'Archivos no cargados'
                    } else if (response.code == 96) {
                        alert.icon = 'error'
                        alert.text = '<p>Archivos no permitidos</p>'
                        alert.title = 'Archivos no cargados'
                    }
                    else {
                        alert.icon = 'error'
                        alert.text = '<p>Hubo un problema al subir los documentos, intente más tarde</p>'
                        alert.title = 'Archivos no cargados'
                    }

                    swal({
                        icon: alert.icon,
                        title: alert.title,
                        text: alert.text,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false
                    }).then(
                        () => {
                            window.scrollTo(0, document.body.scrollHeight);
                        }
                    );

                },
                error => {
                    this.spinner.hide();
                    console.log("un error", error);
                    this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));

                    var subidos = { "archivosSubidos": false };
                    localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
                    swal({
                        icon: 'error',
                        title: 'Error al subir documentación',
                        text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false
                    }).then(
                        () => {
                            window.scrollTo(0, document.body.scrollHeight);
                        }
                    );
                }
            )



        }
        else {
            this._documentosServices.uploadFilesDBX(this.files, formType).subscribe(
                response => {
                    this.spinner.hide();



                    this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));
                    this.adjuntos.forEach(element => {
                        element.estado = "Subido"
                    });
                    localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos))
                    let actualRow = localStorage.getItem("adjuntos");
                    this.rows = JSON.parse(actualRow);
                    console.log('JSON.parse(localStorage.getItem("adjuntos"))', JSON.parse(localStorage.getItem("adjuntos")));

                    var subidos = { "archivosSubidos": true };
                    localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
                    let alert = { icon: 'success', text: '', title: '' }

                    if (response.code == 99 && response.url) {
                        this.cerrarModal();
                        console.log('yasubieron')
                        this.yasubieron = true;

                        alert.icon = 'success'
                        alert.text = '<p>Puedes revisar una vez más tus documentos, usa el siguiente link <br><br> <a mat-stroked-button href="' + response.url + '" style="text-decoration=none" target="_blank"><strong>Descarga tus documentos<strong></a><br><br><br></p>'
                        alert.title = 'Archivos cargados'
                        localStorage.setItem('ZipURL', response.url)
                    } else if (response.code == 98) {
                        alert.icon = 'error'
                        alert.text = '<p>No se adjuntaron documentos</p>'
                        alert.title = 'Archivos no cargados'
                    } else if (response.code == 97) {
                        alert.icon = 'error'
                        alert.text = '<p>No se adjuntaron documentos</p>'
                        alert.title = 'Archivos no cargados'
                    } else if (response.code == 96) {
                        alert.icon = 'error'
                        alert.text = '<p>Archivos no permitidos</p>'
                        alert.title = 'Archivos no cargados'
                    }
                    else {
                        alert.icon = 'error'
                        alert.text = '<p>Hubo un problema al subir los documentos, intente más tarde</p>'
                        alert.title = 'Archivos no cargados'
                    }

                    swal({
                        icon: alert.icon,
                        title: alert.title,
                        text: alert.text,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false
                    }).then(
                        () => {
                            window.scrollTo(0, document.body.scrollHeight);
                        }
                    );

                },
                error => {
                    this.spinner.hide();
                    console.log("un error", error);
                    var subidos = { "archivosSubidos": false };
                    localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
                    swal({
                        icon: 'error',
                        title: 'Error al subir documentación',
                        text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false
                    }).then(
                        () => {
                            window.scrollTo(0, document.body.scrollHeight);
                        }
                    );
                }
            )

        }
    }
}
